export const STORE_MAIN = 'wove'
